// tslint:disable:max-line-length

import React from 'react';

export const OperatorNotEqual = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M6.17 10H4.46V8.38h2.25l.62-1.6H4.46V5.19h3.42l1-2.55h1.88l-1 2.55h1.78v1.6H9.21l-.62 1.6h2.94V10H8l-.83 2.23H5.34z" />
    </svg>
  );
};
